import { useRoutes, Navigate } from "react-router-dom";

import AuthLayout from "components/layout/AuthLayout";
import DashboardLayout from "components/layout/DashboardLayout";

import Login from "pages/login/login.page";
import Dashboard from "pages/main/index.page";
import ChronosGlobalPage from "pages/main/chronos_global.page";
import { IndexPage as CandidatesPage} from "pages/main/candidates/index.page";
import { EditPage as EditCandidatePage } from "pages/main/candidates/edit.page";
import { CreatePage as CreateCandidatePage } from "pages/main/candidates/create.page";
import { IndexPage as OffersPage } from "pages/main/offers/index.page";
import { ShowPage as ShowOfferPage } from "pages/main/offers/show.page";
import { CreatePage as CreateOfferPage } from "pages/main/offers/create.page";
import { EditPage as EditOfferPage } from "pages/main/offers/edit.page";
import { IndexPage as AgentsPage } from "pages/main/agents/index.page";
import { CreatePage as CreateAgentPage } from "pages/main/agents/create.page";
import { EditPage as EditAgentPage } from "pages/main/agents/edit.page";
import { IndexPage as AgenciesPage } from "pages/main/agencies/index.page";
import { CreatePage as CreateAgencyPage} from "pages/main/agencies/create.page";
import { EditPage as EditAgencyPage} from "pages/main/agencies/edit.page";
import { AuthGuard } from "./guards/auth.guard";
import { useAuthStateContext } from "core/auth/hooks";
import { RegistrationsPage } from "pages/main/registrations/index.page";
import { IndexPage as RetoursCandidatsPage } from "pages/main/retours_candidats/index.page";
import { NotificationsPage } from "pages/main/settings/notifications.page";
import { useUserSettingsStateContext } from "core/user.settings/hooks";

export const AppRoutes = () => {
    const {isAuth} = useAuthStateContext();
    const { user } = useUserSettingsStateContext();
    const currentUser = JSON.parse(user || '{}');
    const isAdmin = currentUser.role === 'admin';

    let element = useRoutes([
        {
            path: '/dashboard',
            // element: user ? <DashboardLayout /> : <Navigate to='/auth' />,
            element: <AuthGuard><DashboardLayout /></AuthGuard>,
            children: [
                {path: '', element: <Dashboard />},
                {path: 'chronos-global', element: isAdmin ? <ChronosGlobalPage /> : <Navigate to='/dashboard' />},
                {path: 'stats-globales', element: <Navigate to='/dashboard/chronos-global' replace />},
                {
                    path: 'candidates',
                    children: [
                        {path: '', element: <CandidatesPage />},
                        {path: 'new', element: <CandidatesPage><CreateCandidatePage /></CandidatesPage>},
                        {path: ':candidateId', element: <CandidatesPage><EditCandidatePage /></CandidatesPage>},
                    ]
                },
                {
                    path: 'registrations',
                    children: [
                        { path: '', element: <RegistrationsPage /> },
                    ]
                },
                {
                    path: 'retours-candidats',
                    children: [
                        { path: '', element: <RetoursCandidatsPage /> },
                        { path: ':candidateId', element: <RetoursCandidatsPage><EditCandidatePage /></RetoursCandidatsPage> },
                    ]
                },
                {
                    path: 'offers',
                    children: [
                        {path: '', element: <OffersPage />},
                        {path: 'new', element: <OffersPage><CreateOfferPage/></OffersPage>},
                        {path: ':offerId', element: <OffersPage><ShowOfferPage/></OffersPage>},
                        {path: ':offerId/edit', element: <OffersPage><EditOfferPage/></OffersPage>},
                    ]
                },
                {
                    path: 'agents',
                    children: [
                        {path: '', element: <AgentsPage />},
                        {path: 'new', element: <AgentsPage><CreateAgentPage/></AgentsPage>},
                        {path: ':agentId', element: <AgentsPage><EditAgentPage/></AgentsPage>},
                    ]
                },
                {
                    path: 'agencies',
                    children: [
                        {path: '', element: <AgenciesPage />},
                        {path: 'new', element: <AgenciesPage><CreateAgencyPage/></AgenciesPage>},
                        {path: ':agencyId', element: <AgenciesPage><EditAgencyPage/></AgenciesPage>},
                    ]
                },
                {
                  path: 'settings',
                  children: [
                      {path: 'notifications', element: <NotificationsPage />},
                  ]
              },
          ],
        },
        {
            path: '/auth',
            element: isAuth ? <Navigate to='/dashboard' /> : <AuthLayout />,
            children: [
                {path: '', element: <Login />},
            ],
        },
        { path: '*', element: <Navigate to='/dashboard' /> }
    ]);
    
    return element;
};
